var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScheduleyellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.36 140.55",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 120V31.31c.15-.64.31-1.29.44-1.94a22.8 22.8 0 0122.19-18.59c5.83-.13 11.67 0 17.5 0 .51 0 .57-.4 1.2-.4 0-1.48.06-2.74 0-4-.19-2.98.87-5.11 3.77-6.12h2.53c2.91 1 4 3.15 3.78 6.1-.07 1.29 0 2.58 0 3.87 16.89 0 28-.1 45.06-.1 0-1.38.06-2.66 0-3.93-.18-3 .9-5.17 3.86-6.2h2.56c3 1 4 3.2 3.86 6.2-.08 1.3 0 2.62 0 4.05.77 0 1.15.49 1.67.49 6 0 12-.22 17.93.09 9 .46 15.74 4.81 19.7 13 1.14 2.33 1.59 5 2.36 7.51V120a4.71 4.71 0 00-.27.8c-1.31 8.17-5.66 14.14-13.17 17.62a51.25 51.25 0 01-7.14 2.15H20.57a5.66 5.66 0 00-.79-.27c-8.18-1.3-14.15-5.68-17.62-13.18A50.35 50.35 0 010 120zm11.19-61.75v57.59a14.36 14.36 0 0014.35 14.35h97.26c8.33 0 14.37-6 14.37-14.33V58.25zm.51-11.92h125v-12A13.81 13.81 0 00123 20.44h-16.32c-.36 0-.24.53-.78.53v5.09a4.56 4.56 0 01-3.25 4.57A4.83 4.83 0 0196 25.9v-4.86c-16.56 0-28.89-.15-45.07-.15v4.93a4.52 4.52 0 01-3.06 4.45 4.77 4.77 0 01-6.61-4.61v-4.82c-6.91 0-10.8-.52-16.93-.34C18 20.68 12 26.63 11.74 33c-.19 4.75-.04 8.5-.04 13.33z",
    fill: "#b7b7b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.63 101.27a14.17 14.17 0 01-13.9-13.94 14.35 14.35 0 0113.92-14c7.32 0 14 6.66 14 14a14.37 14.37 0 01-14.02 13.94z",
    fill: "#fca943"
  }))));
}

export default SvgScheduleyellow;